import { LayoutWithSubNav } from '@components/Layout/Layout';
import { navId } from '@containers/Capacity/CapacitySubNav';

export const CapacityLayout = () => LayoutWithSubNav({ navId });
